import './App.css';
import React from 'react';
import Banner from './Layout';

function App() {
  return (
    <div className="App">
      <Banner />
    </div>
  );
}

export default App;